import { Skeleton } from "@/components/ui/skeleton";

interface LoadingStateProps {
  type?: "grid" | "spinner" | "kanban";
  message?: string;
}

export function LoadingState({ type = "grid", message = "Cargando..." }: LoadingStateProps) {
  if (type === "spinner") {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <div className="relative">
          <div className="absolute inset-0 rounded-full blur-xl bg-blue-500/20 animate-pulse"></div>
          <div className="h-12 w-12 rounded-full border-4 border-slate-100 border-t-blue-600 animate-spin relative z-10"></div>
        </div>
        <p className="mt-6 text-lg font-medium text-slate-600 animate-pulse">{message}</p>
      </div>
    );
  }

  if (type === "kanban") {
    return (
      <div className="w-full">
        <div className="flex gap-4 overflow-x-auto pb-4 custom-scrollbar">
          {Array.from({ length: 4 }).map((_, colIndex) => (
            <div key={colIndex} className="min-w-[320px] w-[320px] bg-slate-50/50 rounded-[24px] border border-slate-100 flex flex-col p-4 shadow-sm h-[500px]">
              <div className="flex items-center justify-between mb-4 px-1">
                <Skeleton className="h-6 w-1/2 bg-slate-200/60 rounded-full" />
                <Skeleton className="h-5 w-8 bg-slate-200/60 rounded-full" />
              </div>
              <div className="space-y-3 flex-1 overflow-hidden">
                {Array.from({ length: 3 }).map((_, cardIndex) => (
                  <div key={cardIndex} className="bg-white p-4 rounded-[20px] shadow-sm border border-slate-100 space-y-3">
                    <Skeleton className="h-5 w-3/4 bg-slate-200/60 rounded-full" />
                    <Skeleton className="h-4 w-1/2 bg-slate-200/60 rounded-full" />
                    <div className="flex justify-between items-center pt-2 mt-2 border-t border-slate-50">
                      <Skeleton className="h-4 w-12 bg-slate-200/60 rounded-full" />
                      <Skeleton className="h-6 w-16 bg-slate-200/60 rounded-full" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-4">
          <p className="text-sm font-medium text-slate-400 animate-pulse">{message}</p>
        </div>
      </div>
    );
  }

  // Default to grid skeleton for cards
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div 
            key={i} 
            className="bg-slate-50/40 rounded-[24px] border-2 border-slate-100 p-6 shadow-sm"
          >
             <div className="flex items-start space-x-4 mb-6">
               <Skeleton className="h-14 w-14 rounded-full bg-slate-200/60" />
               <div className="space-y-3 flex-1 pt-1">
                 <Skeleton className="h-5 w-3/4 bg-slate-200/60 rounded-full" />
                 <Skeleton className="h-4 w-1/2 bg-slate-200/60 rounded-full" />
               </div>
             </div>
             <div className="space-y-3">
               <Skeleton className="h-4 w-full bg-slate-200/60 rounded-full" />
               <Skeleton className="h-4 w-5/6 bg-slate-200/60 rounded-full" />
               <Skeleton className="h-4 w-4/6 bg-slate-200/60 rounded-full" />
             </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center mt-8">
        <p className="text-sm font-medium text-slate-400 animate-pulse">{message}</p>
      </div>
    </div>
  );
}
